module.exports = __webpack_public_path__ + "static/Insight Network-802a4c4085c181e9e27787f884cd8298.jpg";